<template>
  <div class="box">

    <Banner :banner-img="bannerImg" :style-height="styleHeight" :text-style="textStyle" :banner-h="bannerH"
            :banner-p="bannerP"></Banner>
    <scroll-animate>
      <!--    产品详情-->
      <div class="productDetails core_box">
        <div class="product_Top">
          <div class="product_img">
            <img :src="swiperOpen"/>

            <div class="product_img_item">
            <span v-for="(item,index) in productParam.catgImg" :key="index">
              <img :src="item" @mousemove="swiperMove($event,item)" @mouseout="swiperOut($event)"/>
            </span>
            </div>
            <!--          <img :src="productParam.catgImg">-->
          </div>
          <div class="product_text">
            <h1>
              {{ currentLanguageProductName }}
              <span class="ctct" @click.stop="ctctRouter">{{ $t('contact.title') }} <em
                  class="el-icon-right"></em></span>
            </h1>
            <div class="product_text_text">
              <p style="border-radius: 10px" v-for="(item,index) in currentLanguageProductIntroduce" :key="index" class="el-icon-caret-right">
                {{ item }}</p>
            </div>
          </div>
        </div>
      </div>
    </scroll-animate>

    <scroll-animate>

      <div class="paramShowBox" v-if="JSON.stringify(productParam.productParamItem)!='[]'">
        <h1>{{ $t('products.specifications') || '规格参数' }}</h1>
        <div class="paramShow">
          <div class="paramItem" v-for="(item,index) in productParam.productParamItem" :key="index">
            <span>{{ getParamName(item.name) }}</span>
            <p v-for="(item_param,index) in item.params" :key="index">
              <span>{{ getParamKey(item_param.key) }}</span>
              <em>{{ getParamValue(item_param.key, item_param.value) }}</em>
            </p>
          </div>
        </div>
      </div>
    </scroll-animate>

  </div>
</template>

<script>
import Banner from "@/components/banner.vue";
import {product} from "@/assets/js/productParam.js"
import $ from "jquery"
import ScrollAnimate from "./ScrollAnimate.vue";

export default {
  name: 'productInfoShow',
  components: {
    ScrollAnimate,
    Banner
  },
  data() {
    return {
      bannerImg: require("../assets/img/banner-bg/bg1.png"),
      bannerH: "",
      bannerP: this.$t('products.productDetails') || "产品详细参数",
      styleHeight: {
        height: "300px",
      },
      textStyle: {
        height: "94%"
      },
      productParam: [],
      swiperOpen: '', // 轮播图大个
      flag: true,
      productKey: '', // 用于查找对应的翻译
      // 参数值翻译映射表
      paramValueMap: {
        // 非冷凝对应翻译
        '10%~90%（非冷凝）': '10%~90% (Non-condensing)',
        '0%-90%( 在不凝结水滴状态下 )': '0%-90% (Non-condensing)',
        '20~90%RH，无冷疑': '20~90%RH, Non-condensing',

        // 材质对应翻译
        '铝': 'Aluminum',
        '金属': 'Metal',
        '金属外壳': 'Metal Housing',
        'ABS+PC 磨砂外壳': 'ABS+PC Frosted Shell',
        'ABS+PC磨砂外壳': 'ABS+PC Frosted Shell',
        '塑料面板': 'Plastic Panel',
        '锌合金': 'Zinc Alloy',
        '防火阻燃V0级ABS': 'Fire-resistant V0 Grade ABS',
        '航空级铝合金': 'Aviation-grade Aluminum Alloy',
        '亚克力': 'Acrylic',
        '高强度工程塑料': 'High-strength Engineering Plastic',

        // 颜色对应翻译
        '银色、黑色': 'Silver, Black',
        '黑色、白色': 'Black, White',
        '碳灰色': 'Carbon Gray',
        '可定制': 'Customizable',
        '银白色': 'Silver White',
        '黑色': 'Black',
        '白色': 'White',
        '银色': 'Silver',
        '土豪金': 'Luxury Gold',

        // 安装方式对应翻译
        '适合埋入式86电器盒使用': 'Suitable for 86-type Embedded Box',
        '表面安装、嵌入式安装': 'Surface or Embedded Installation',
        '表面安装': 'Surface Mounting',
        '嵌入式安装': 'Embedded Installation',
        '明装/暗装': 'Surface/Flush Mounting',
        '螺丝固定': 'Screw Mounting',

        // 工作方式对应翻译
        '通电弹开 / 断电手动关门上锁': 'Power-on Ejection / Manual Close when Power Off',
        '上锁闭合 / 开锁断开': 'Locked Closed / Unlocked Open',
        '上电闭合，断电释放': 'Power-on Locked, Power-off Released',
        '支持有电上锁/有电开锁': 'Supports Power-on Locking/Power-on Unlocking',

        // 标准输出对应翻译
        '韦根 (RS232 和 RS485 可选 )': 'Wiegand (RS232 and RS485 optional)',
        '韦根 (RS232 和 RS485 可选)': 'Wiegand (RS232 and RS485 optional)',
        '韦根26/34位可选': 'Wiegand 26/34 bit optional',
        'RS232/485/TCP/IP': 'RS232/485/TCP/IP',
        'Wiegand 26/34': 'Wiegand 26/34',

        // 工作电压翻译
        '7~17Vdc': '7~17Vdc',
        '7~28Vdc': '7~28Vdc',
        '7~16VDC': '7~16VDC',
        '3~6Vdc': '3~6Vdc',
        'DC12V ±10%': 'DC12V ±10%',
        '12v/24v': '12v/24v',
        'DC 12V': 'DC 12V',
        'DC 5V': 'DC 5V',
        'DC12V': 'DC12V',
        'DC 9~24V': 'DC 9~24V',
        '3x 1.5V AAA 碱性电池': '3x 1.5V AAA Alkaline Batteries',
        'AC100-240V': 'AC100-240V',
        'DC 24V': 'DC 24V',

        // 工作温度
        '-10℃~55℃': '-10°C~55°C',
        '-20℃~60℃': '-20°C~60°C',
        '-30℃~60℃': '-30°C~60°C',
        '-40℃~70℃': '-40°C~70°C',

        // 工作湿度
        '10%~90%': '10%~90%',
        '0%~95%': '0%~95%',

        // 读卡频率
        '13.56MHz': '13.56MHz',
        '125KHz': '125KHz',
        '13.56MHz/125KHz': '13.56MHz/125KHz',
        '13.56MHz（ISO14443A）': '13.56MHz (ISO14443A)',

        // 其他参数值翻译
        '支持通电开锁 / 断电开锁': 'Supports Power-on or Power-off Unlocking',
        '<5KG': '<5KG',
        'IP65': 'IP65',
        'IP64': 'IP64',
        'IP54': 'IP54',
        'IP66': 'IP66',
        'LCD': 'LCD',
        'Android8.1': 'Android 8.1',
        '蜂鸣器': 'Buzzer',
        '电源指示灯和状态指示灯': 'Power and Status Indicators',
        '重启后半小时内': 'Within 30 Minutes After Restart',
        '-': '-',

        // 产品尺寸
        '115mm*56mm*22mm': '115mm*56mm*22mm',
        '86mm*86mm*15mm': '86mm*86mm*15mm',
        '40mm*30mm*25mm': '40mm*30mm*25mm',
        '185mm*62mm*39mm': '185mm*62mm*39mm',

        // 读卡距离
        '3-8cm': '3-8cm',
        '2-5cm': '2-5cm',
        '2-6cm': '2-6cm',
        '0-3cm': '0-3cm',

        // 功率相关
        '≤3W': '≤3W',
        '≤5W': '≤5W',
        '≤10W': '≤10W',
        '≤ 30mA': '≤ 30mA',
        '≤ 50mA': '≤ 50mA',
        '≤ 100mA': '≤ 100mA',
        '≤ 200mA': '≤ 200mA',
        '≤ 0.5W': '≤ 0.5W',
        '≤ 1W': '≤ 1W',

        // 处理器和内存
        '四核 1.4GHz': 'Quad-core 1.4GHz',
        'ARM Cortex A7 四核 1.2GHz': 'ARM Cortex A7 Quad-core 1.2GHz',
        '高通骁龙处理器': 'Qualcomm Snapdragon Processor',
        '2GB + 16GB': '2GB + 16GB',
        '1GB + 8GB': '1GB + 8GB',
        '4GB + 64GB': '4GB + 64GB',

        // 显示屏相关
        '8英寸IPS': '8-inch IPS',
        '7英寸触控屏': '7-inch Touch Screen',
        '5英寸高清': '5-inch HD',
        '16:9--1280x720': '16:9--1280x720',
        '16:9--1920x1080': '16:9--1920x1080',

        // 特定功能描述
        '刷卡/密码/指纹': 'Card/Password/Fingerprint',
        '刷卡/指纹': 'Card/Fingerprint',
        '刷卡/密码': 'Card/Password',
        '刷卡': 'Card Swipe',
        'RFID卡片': 'RFID Card',
        '壁挂式': 'Wall-mounted',
        '门磁检测': 'Door Contact Detection',
        '红外遥控': 'Infrared Remote Control',
        '网络通讯': 'Network Communication',
        'TCP/IP': 'TCP/IP',
        'PoE供电': 'PoE Power Supply',
        '云平台管理': 'Cloud Platform Management',
        '生物识别': 'Biometric Identification',
        '活体检测': 'Liveness Detection',
        '设置APP': 'Configuration APP',
        'NFC功能': 'NFC Function',
        '脱机使用': 'Offline Usage',
        '离线警报': 'Offline Alarm',
        '电池供电': 'Battery Powered',
        '可充电锂电池': 'Rechargeable Lithium Battery',

        // 其他说明性文字
        '万': '10,000',
        '标配': 'Standard',
        '选配': 'Optional',
        '带': 'with',
        '不带': 'without',
        '内置': 'Built-in',
        '外置': 'External',
        '支持': 'Supported',
        '不支持': 'Not Supported',
        '防水': 'Waterproof',
        '防尘': 'Dust-proof',
        '防拆': 'Tamper-proof',
        '超低功耗': 'Ultra-low Power Consumption',
        '高安全性': 'High Security',
        '多点': 'Multi-point',
        '单点': 'Single-point',
        '液晶显示屏': 'LCD Display',
        '指示灯': 'Indicator Light',
        '双色指示灯': 'Dual-color Indicator',
        '消防联动': 'Fire Alarm Linkage',
        '报警联动': 'Alarm Linkage',
        '远程控制': 'Remote Control',
        '远程管理': 'Remote Management',
        '远程开锁': 'Remote Unlock',
        '用户管理': 'User Management',
        '权限管理': 'Permission Management',
        '出入记录': 'Access Records',
        '实时监控': 'Real-time Monitoring',
        '接入控制': 'Access Control',
        '管理软件': 'Management Software',
        '手机APP': 'Mobile APP',
        '室内': 'Indoor',
        '室外': 'Outdoor'
      }
    }
  },
  computed: {
    currentLanguageProductName() {
      // 根据产品ID获取翻译后的产品名称
      if (this.productKey) {
        const translatedName = this.$t(`products.productParam.products.${this.productKey}.name`);
        if (translatedName && translatedName !== `products.productParam.products.${this.productKey}.name`) {
          return translatedName;
        }
      }
      return this.productParam.productName || '';
    },
    currentLanguageProductIntroduce() {
      // 根据产品ID获取翻译后的产品特性
      if (this.productKey) {
        const features = [];
        if (this.productParam.productIntroduce) {
          for (let i = 0; i < this.productParam.productIntroduce.length; i++) {
            // 尝试获取翻译
            const translationKey = `products.productParam.products.${this.productKey}.features[${i}]`;
            const translation = this.$t(translationKey);
            // 如果翻译存在则使用翻译，否则使用原文
            if (translation && translation !== translationKey) {
              features.push(translation);
            } else {
              features.push(this.productParam.productIntroduce[i]);
            }
          }
        }
        if (features.length > 0) {
          return features;
        }
      }
      return this.productParam.productIntroduce || [];
    }
  },
  methods: {
    ctctRouter() {
      this.$router.push("/contact")
    },
    swiperMove(event, imgSrc) {
      if (this.flag) {
        this.flag = false
        $(".product_img_item>span>img").css("border", "none")
        $(event.target).css("border", "2px solid #2b64ad")
        this.swiperOpen = imgSrc
      }
    },
    swiperOut($event) {
      if (!this.flag) {
        this.flag = true
      }
    },
    getParamName(name) {
      // 定义参数名称的中英文映射
      const nameMap = {
        '设备参数': 'deviceParams',
        '使用参数': 'usageParams'
      };

      // 1. 先尝试直接查询映射
      if (nameMap[name]) {
        return this.$t(`products.productParam.parameters.${nameMap[name]}`);
      }

      // 2. 尝试在已知的参数中查找匹配项
      const paramKeys = Object.keys(this.$t('products.productParam.parameters'));
      for (const key of paramKeys) {
        if (this.$t(`products.productParam.parameters.${key}`) === name) {
          return this.$t(`products.productParam.parameters.${key}`);
        }
      }

      return name;
    },
    getParamKey(key) {
      // 定义参数键的中英文映射
      const keyMap = {
        '工作电压': 'workingVoltage',
        '读卡频率': 'cardFrequency',
        '读卡器配置': 'readerConfig',
        '标准输出': 'standardOutput',
        '读卡器输出格式': 'readerOutputFormat',
        '读卡器输出格式：': 'readerOutputFormat',
        '输入控制': 'inputControl',
        '韦根宽度': 'wiegandWidth',
        '键盘格式': 'keypadFormat',
        '读卡距离': 'readDistance',
        '防水等级': 'waterproofLevel',
        '产品尺寸': 'productSize',
        '外壳材质': 'shellMaterial',
        '产品颜色': 'productColor',
        '工作温度': 'workingTemperature',
        '工作湿度': 'workingHumidity',
        '适用门厚度': 'doorThickness',
        '尺寸': 'size',
        '把手转动角度': 'handleRotationAngle',
        '把手至锁芯的距离': 'handleToCylinderDistance',
        '操作系统': 'operatingSystem',
        '人脸识别': 'faceRecognition',
        '主要芯片规格': 'mainChipSpecs',
        '内存': 'memory',
        '内 存': 'memory',
        'WiFi蓝牙模块': 'wifiBluetoothModule',
        'WiFi 蓝牙模块': 'wifiBluetoothModule',
        '设备尺寸(长宽高)': 'deviceSize',
        '设备尺寸 ( 长宽高 )': 'deviceSize',
        '摄像头模组(双目)': 'cameraModule',
        '摄像头模组 ( 双目 )': 'cameraModule',
        '补光灯': 'fillLight',
        '显示屏': 'display',
        '屏幕比例--分辨率': 'screenRatio',
        '屏幕比例 -- 分辨率': 'screenRatio',
        '设备电源': 'devicePower',
        '设备功率': 'deviceWattage',
        '处理器': 'processor',
        '储存容量': 'storageCapacity',
        '工作电流': 'workingCurrent',
        '报警输出': 'alarmOutput',
        '电锁继电器': 'lockRelay',
        '可承受里力': 'bearableForce',
        '开锁方式': 'unlockMethod',
        '锁体尺寸': 'lockBodySize',
        '锁扣板尺寸': 'lockPlateSize',
        '电气参数': 'electricalParams',
        '工作方式': 'workingMode',
        '反馈信号': 'feedbackSignal',
        '开门弹力': 'doorOpeningForce',
        '吸板尺寸': 'suctionPlateSize',
        '承受拉力': 'tensileStrength',
        '安装方式': 'installationMethod',
        '最大输出功率': 'maxOutputPower',
        '输出电压': 'outputVoltage',
        '最大输出电流': 'maxOutputCurrent',
        '单路输出电流': 'singleChannelOutputCurrent',
        '输入电压': 'inputVoltage',
        '最大输入电流': 'maxInputCurrent',
        '待机功耗': 'standbyPowerConsumption',
        '输出保护': 'outputProtection',
        '输出总电流': 'totalOutputCurrent',
        '外观材质': 'appearanceMaterial',
        '报警声音': 'alarmSound',
        '通讯协议': 'communicationProtocol',
        '通讯接口': 'communicationInterface',
        '指示灯': 'indicatorLight',
        '结构': 'structure',
        '防护等级': 'protectionLevel',
        '读取距离': 'readingDistance',
        '读卡器接口': 'cardReaderInterface',
        '电锁接口': 'lockInterface'
      };

      // 1. 先尝试直接查询映射
      if (keyMap[key]) {
        return this.$t(`products.productParam.parameters.${keyMap[key]}`);
      }

      // 2. 尝试在已知的参数中查找匹配项
      const paramKeys = Object.keys(this.$t('products.productParam.parameters'));
      for (const paramKey of paramKeys) {
        if (this.$t(`products.productParam.parameters.${paramKey}`) === key) {
          return this.$t(`products.productParam.parameters.${paramKey}`);
        }
      }

      return key;
    },
    getParamValue(key, value) {
      // 如果当前是英文界面，查询参数值翻译
      if (this.$i18n.locale === 'en-US') {
        // 1. 先尝试从常用翻译映射中找
        if (this.paramValueMap[value]) {
          return this.paramValueMap[value];
        }

        // 2. 添加特定参数值的即时翻译
        // 这些是实际产品中出现的，但尚未添加到映射表的值
        const specificValues = {
          '116mm*85mm*18.5mm（标准）': '116mm*85mm*18.5mm (Standard)',
          '125KHz：HID 兼容卡格式、EM 26bits（默认）13.56MHz： UID 32bits, 34bits, 56bits ( 反向 /正向 ), 已编写的卡号': '125KHz: HID compatible card format, EM 26bits (default) 13.56MHz: UID 32bits, 34bits, 56bits (reverse/forward), programmed card number',
          '输入：三色 LED，蜂鸣器，保持低电平有效': 'Input: Three-color LED, buzzer, active low',
          '125K：≥ 5cm': '125K: ≥ 5cm',
          '125KHz、13.56MHz': '125KHz, 13.56MHz',
          '16:9 -- 720*1280/8001280': '16:9 -- 720*1280/8001280',
          '12VDC 土 10%.2A': '12VDC ±10%, 2A',
          '-30~75C': '-30~75°C',
          '干接点输出（可选标准Wiegand 26/34和RS485)': 'Dry contact output (optional standard Wiegand 26/34 and RS485)',
          '报警输出：继电器干接点（30VDC，1A max）': 'Alarm output: Relay dry contact (30VDC, 1A max)',
          '0~1A MAX，NC/COM/NO 格式': '0~1A MAX, NC/COM/NO format'
        };

        if (specificValues[value]) {
          return specificValues[value];
        }

        // 3. 尝试从i18n中查找
        const valueTranslationKey = `products.productParam.values.${key}`;
        const translation = this.$t(valueTranslationKey);
        if (translation && translation !== valueTranslationKey) {
          return translation;
        }

        // 4. 特殊类型的参数值智能处理
        // 处理带有"mm"的尺寸
        if (value.includes('mm') || value.includes('MM')) {
          return value;
        }

        // 处理温度值
        if (value.includes('℃')) {
          // 将中文℃替换成英文℃
          return value.replace('℃', '°C');
        }

        // 处理电压值
        if (/\d+V/.test(value)) {
          return value;
        }

        // 处理带中文括号的说明
        if (value.includes('（') && value.includes('）')) {
          return value.replace('（', ' (').replace('）', ')');
        }

        // 处理带中文的说明性文字
        const chineseExplanations = {
          '根据不同控制器的要求有不同的选择': 'Different options based on controller requirements',
          '4bits/8bits/26bits（针对键盘读卡器）': '4bits/8bits/26bits (for keypad readers)',
          '根据不同技术': 'depends on technology',
          '锁没有工作时': 'when lock is not operating',
          '支持有电锁，无电锁': 'supports power-on and power-off locks',
          '支持门磁输入': 'supports door contact input',
          '支持红色，绿色指示灯反馈': 'supports red and green LED feedback',
          '适用范围：抽屉、移门、柜门等': 'Applicable for: drawers, sliding doors, cabinet doors, etc.',
          '输出短路、过流、过压、过温保护': 'Output short circuit, overcurrent, overvoltage, and overtemperature protection',
          '自带机箱和供电电源': 'Built-in housing and power supply',
          '功耗≤': 'Power consumption ≤',
          '不带负载': 'without load',
          '双目 200W，可见光 + 近红外': '200W Dual, Visible Light + NIR',
          '最大 10 万人；1:1 模式、1:N 模式、混合模式': 'Max 100,000 users; 1:1 mode, 1:N mode, hybrid mode',
          '5 万张卡和 10 万离线记录存储': '50,000 cards and 100,000 offline records',
          '10 路电锁': '10-channel electric lock',
          '支持门磁输入2A@12V 电锁': 'supports door contact input, 2A@12V electric lock',
          '支持红色，绿色指示灯反馈5VDC 电源': 'supports red and green indicator feedback, 5VDC power supply',
          '韦根读卡器接口': 'Wiegand reader interface',
          '韦根 (RS232 和 RS485 可选)': 'Wiegand (RS232 and RS485 optional)',
          '干接点输出': 'dry contact output',
          '1~5 通道最大 5A 电流，6-9 通道最大 3A 电流': 'Channels 1-5 max 5A current, channels 6-9 max.3A current',
          '宽 * 深 * 高': 'W * D * H',
          '刷卡/密码/指纹：1万个用户': 'Card/Password/Fingerprint: 10,000 users',
          '单指纹、卡+指纹模式': 'Single fingerprint, card + fingerprint mode',
          '以太网/WiFi': 'Ethernet/WiFi',
          '卡容量': 'Card Capacity',
          '人脸容量：': 'Facial Capacity:',
          '指纹容量：': 'Fingerprint Capacity:',
          '密码容量：': 'Password Capacity:',
          '记录容量：': 'Record Capacity:',
          '动态二维码': 'Dynamic QR Code',
          '长宽高': 'Length × Width × Height',
          '适合办公环境使用': 'Suitable for office environment',
          '厚度小于': 'Thickness less than',
          '壁厚': 'Wall Thickness',
          '至少': 'At least',
          '最多': 'Maximum',
          '蓝牙解锁': 'Bluetooth unlock',
          '手机APP远程控制': 'Mobile APP remote control',
          '卡片管理': 'Card management',
          '脱机工作': 'Offline operation',
          '微信小程序': 'WeChat Mini Program',
          '数据库': 'Database',
          '系统接口': 'System interface',
          '管理平台': 'Management platform',
          '锂电池供电': 'Lithium battery powered',
          '电池寿命': 'Battery life',
          '可更换电池': 'Replaceable battery',
          '电池类型': 'Battery type',
          '电池电量显示': 'Battery level display',
          '低电量提醒': 'Low battery alert',
          '电池不足时断电自动开锁': 'Automatic unlocking when battery is low',
          '防锁设计': 'Anti-lock design',
          '预留机械钥匙孔': 'Reserved mechanical key hole',
          '工作时长': 'Working duration',
          '智能检测': 'Smart detection',
          '存储扩展': 'Storage expansion',
          '自动锁定': 'Auto locking',
          '布线简单': 'Simple wiring',
          '防暴力撬动': 'Anti-force prying',
          '嵌入式系统': 'Embedded system',
          '单机工作': 'Standalone operation',
          '内置传感器': 'Built-in sensor'
        };

        for (const [chinese, english] of Object.entries(chineseExplanations)) {
          if (value.includes(chinese)) {
            return value.replace(chinese, english);
          }
        }

        // 处理中文数字和单位的组合
        // 例如：10万用户 -> 100,000 users
        const numberPattern = /(\d+)万/g;
        if (numberPattern.test(value)) {
          return value.replace(numberPattern, (match, p1) => `${p1}0,000`);
        }

        // 处理混合中英文的参数值
        // 例如：最大3A电流 -> Maximum 3A current
        if (/[\u4e00-\u9fa5]/.test(value) && /[a-zA-Z0-9]/.test(value)) {
          let translatedValue = value;

          // 常见中文词汇替换
          const commonTerms = {
            '最大': 'Maximum ',
            '最小': 'Minimum ',
            '标准': 'Standard ',
            '可选': 'Optional ',
            '电流': ' current',
            '电压': ' voltage',
            '功率': ' power',
            '频率': ' frequency',
            '尺寸': ' size',
            '类型': ' type',
            '容量': ' capacity',
            '模式': ' mode',
            '接口': ' interface',
            '协议': ' protocol',
            '速度': ' speed',
            '精度': ' accuracy',
            '分辨率': ' resolution',
            '灵敏度': ' sensitivity',
            '使用': ' use',
            '支持': ' support',
            '数量': ' quantity',
            '重量': ' weight',
            '长度': ' length',
            '宽度': ' width',
            '高度': ' height',
            '温度': ' temperature',
            '湿度': ' humidity',
            '时间': ' time',
            '范围': ' range',
            '等级': ' level',
            '供电': ' power supply'
          };

          for (const [chinese, english] of Object.entries(commonTerms)) {
            if (translatedValue.includes(chinese)) {
              translatedValue = translatedValue.replace(chinese, english);
            }
          }

          if (translatedValue !== value) {
            return translatedValue;
          }
        }
      }

      // 如果找不到翻译或者是中文界面，返回原始值
      return value;
    },
    findProductKey() {
      // 查找产品对应的翻译键
      // 根据产品ID匹配对应键名
      const idKeyMap = {
        "CP-636456385274-sjz": "accessControlCardReader",
        "CP-636456385274-sz": "accessControlCardReaderFingerprint",
        "CP-636456385274-sj": "accessControlCardReaderKeypad",
        "CP-636456385274-s": "accessControlCardReaderSwipe",
        "CP-9894263426786": "wirelessElectronicLock",
        "CP-989897546892154": "pullLock",
        "CP-763542674424354": "faceRecognitionMachine",
        "CP-636546566494474": "accessController",
        "CP-9349464342694786": "miniatureElectronicLock",
        "CP-7446364826743786": "smartEjectionLock",
        "CP-269482642454786": "concealedMagneticLock",
        "CP-98269489464385274": "cylindricalCardReader",
        "CP-946744385274": "implicitCardReader",
        "CP-968548532157896": "allInOneCardReader",
        "CP-744636566494474": "tenDoorController",
        "CP-326636566494474": "singleDoorController",
        "CP-726636566494474": "threeDoorController",
        "CP-897546123547895": "sixDoorController",
        "CP-542436434269826": "integratedPowerSupply",
        "CP-524482634269826": "switchingPowerSupply",
        "CP-598746215874651": "contactFreeSwitch"
      };

      // 1. 直接根据ID匹配
      if (this.productParam && this.productParam.id && idKeyMap[this.productParam.id]) {
        this.productKey = idKeyMap[this.productParam.id];
        return;
      }

      // 2. 根据产品名称匹配
      if (this.productParam && this.productParam.productName) {
        const productNames = {
          "门禁读卡器(刷卡/键盘/指纹)": "accessControlCardReader",
          "门禁读卡器(刷卡/指纹)": "accessControlCardReaderFingerprint",
          "门禁读卡器(刷卡/键盘)": "accessControlCardReaderKeypad",
          "门禁读卡器(刷卡)": "accessControlCardReaderSwipe",
          "无线电锁": "wirelessElectronicLock",
          "拉手锁": "pullLock",
          "人脸识别机": "faceRecognitionMachine",
          "门禁控制器": "accessController",
          "微型电子锁": "miniatureElectronicLock",
          "智能弹射锁": "smartEjectionLock",
          "暗装磁力锁": "concealedMagneticLock",
          "圆柱形读卡器(明装)": "cylindricalCardReader",
          "读卡器(隐式安装)": "implicitCardReader",
          "读卡器一体机": "allInOneCardReader",
          "储物柜专用十门控制器": "tenDoorController",
          "单门控制器": "singleDoorController",
          "三门控制器": "threeDoorController",
          "六门控制器": "sixDoorController",
          "专用集成电源": "integratedPowerSupply",
          "开关电源": "switchingPowerSupply",
          "免接触开门按钮": "contactFreeSwitch"
        };

        const productKey = productNames[this.productParam.productName];
        if (productKey) {
          this.productKey = productKey;
          return;
        }
      }
    }
  },
  mounted() {
    const productId = this.$route.query.item
    for (var i = 0; i < product.length; i++) {
      if (product[i].id == productId) {
        this.productParam = product[i]
        this.bannerH = this.productParam.productName
      }
    }

    // 查找产品对应的翻译键
    this.findProductKey();

    // 处理产品名称中的括号部分
    const productNameIndex = this.productParam.productName.indexOf("(")
    if (productNameIndex != -1) {
      this.bannerH = this.productParam.productName.substring(0, productNameIndex)
      this.bannerP = this.productParam.productName.substring(productNameIndex + 1, this.productParam.productName.length - 1)
      this.productParam.productName = this.bannerH
    }

    this.swiperOpen = this.productParam.catgImg[0]

    // 恢复点击显示产品特点功能
    let clickText = ''
    $(function () {
      $(".product_text_text>p").on("click", function () {
        if (clickText !== $(this).text()) {
          $(".product_text_text>p").removeClass("productInfoSelect")
        }
        clickText = $(this).text()
        $(this).toggleClass("productInfoSelect")
      })

      let content = document.querySelector('.product_img_item')
      if (content) {
        content.addEventListener('wheel', event => {
          event.preventDefault()
          content.scrollLeft -= -event.deltaY
        })
      }
    })
  }
}
</script>

<style scoped lang="scss">
.box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.productDetails {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  background-color: white;
  border-radius: 15px;
}

.product_Top {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.product_img {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 500px;
  height: 500px;
  overflow: hidden;

  .product_img_item {
    display: flex;
    flex-direction: row;
    justify-content: left;
    width: 25rem;
    overflow-x: scroll;
    align-content: space-around;
    scrollbar-width: thin; /*火狐滚动条变细*/
    /*第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式)*/
    scrollbar-color: $shanMai_green rgba(0, 0, 0, 0.1);

    &::-webkit-scrollbar {
      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $shanMai_green;
      border-radius: 1px;
    }

    span {
      cursor: pointer;
      margin-top: 1rem;
      transition: all .2s;

      img {
        display: block;
        box-sizing: border-box;
        width: 5rem;
        height: 4.8rem;
        object-fit: cover;
      }
    }
  }


  img {
    //width: 20rem;
    height: 19.8rem;
  }
}

/*适配手机*/
.product_text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: space-around;
  width: 450px;
  color: #444444;

  @media screen and (max-width: 460px) {
    width: 400px !important;
  }

  h1 {
    margin-bottom: 0.5rem;
    margin-left: 15px;

    @media screen and (max-width: 460px) {
      font-size: 24px;
    }

  }

  .product_text_text {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    transition: all .2s;

    p {
      display: inline-block;
      width: 44%;
      line-height: 1.5;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      cursor: pointer;
      user-select: none;
      word-break: break-all;
      padding: 1rem;
      transition: all .2s;
      @media screen and (max-width: 460px) {
        font-size: 12px !important;
      }
    }
  }
}

.productInfoSelect {
  text-overflow: inherit !important;
  overflow: visible !important;
  white-space: pre-line !important;
  background: #2b2b2b !important;
  color: white !important;
}

.ctct {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
  width: 100px;
  padding: 5px 10px;
  margin-top: 20px;
  border-radius: 10px;
  background-color: #eeeeee;
  color: #444;
  cursor: pointer;
  user-select: none;
  font-size: 1rem;
  transition: background-color, color ease-in 0.2s;

  @media screen and (max-width: 460px) {
    font-size: 14px !important;
  }

  &:hover {
    background-color: #666;
    color: white;
  }
}

.paramShowBox {
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 800px;
  margin-top: 100px;
  background-color: rgb(80, 80, 80);
  border-radius: 15px;
  margin-left: auto;
  margin-right: auto;

  h1 {
    padding-top: 1rem;
    text-align: center;
    color: white;
  }
}

.paramShow {
  width: 90%;
  height: 37.5rem;
  background-color: white;
  margin-top: 3rem;
  margin-left: 5rem;
  margin-right: 5rem;
  border-radius: 20px;
  overflow: auto;
}

.paramItem {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 1rem;
  padding: 0 2rem;

  span {
    color: #d7000f;
    font-width: 900;
  }

  p {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0.6rem 0;
    border-bottom: 1px solid #a3a3a3;
    font-width: 700;
    font-size: 1rem;

    span {
      color: black;
      display: block;
      width: 10rem;
    }

    em {
      width: 100%;
      max-width: 20rem;
      margin-left: 1.2rem;
      border: none;
      font-size: 1rem;
      color: #7d7d7d;
      background-color: white;
      text-align: left;
      line-height: 1.5;
      vertical-align: middle;
    }
  }
}

</style>
